import { useCallback } from 'react';
import { useRouter } from '@/hooks';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { StructuresList } from './StructuresList';
import { BackButton } from './BackButton';

export const TemplateBuilder = () => {
  const router = useRouter();

  const handlePlatformClick = useCallback(
    (structureId: string) => {
      router.push({
        pathname: `/template-builder/${structureId}`,
      });
    },
    [router]
  );

  return (
    <Container
      sx={{
        height: '100vh',
        paddingBottom: '10rem',
        width: '100%',
        overflow: 'scroll',
        msOverflowStyle: 'none',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
      }}
    >
      <Stack
        direction="row"
        spacing={3}
        sx={{ display: 'flex', alignItem: 'center', pb: 2, mt: 2 }}
      >
        <BackButton />
        <Typography variant="h6" sx={{ pt: 1 }}>
          Template Builder
        </Typography>
      </Stack>
      <Typography variant="h6">Select a structure to view templates</Typography>
      <StructuresList onPlatformClick={handlePlatformClick} drawerOpen={false} />
    </Container>
  );
};
